// generated by genversion
export const version = '4.7.3';



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = ./src/version.js
// module chunks = main